import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/services/core/base/base.service';

const routes = {
  dishes: 'menus/category',
  dishItem: 'menus'
};

@Injectable({
  providedIn: 'root',
})
export class DishService extends BaseService<any> {
  constructor(public http: HttpClient) {
    super(http);
  }

  getAllDishes(restaurantId: number): Observable<any> {
    return this.sendGet(this.baseUrl(`${routes.dishes}/${restaurantId}`));
  }

  getDishItem(dishId: number): Observable<any> {
    return this.sendGet(this.baseUrl(`${routes.dishItem}/${dishId}`));
  }
}
